import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface RemoveKnowledgeByTypeFromCandidateResponse
  extends BackendResponse {}
export interface RemoveKnowledgeByTypeFromCandidateParameters
  extends NextApiParams {
  knowledgeTypeId: number;
}

export const removeKnowledgeByTypeFromCandidate = withNextApi<
  RemoveKnowledgeByTypeFromCandidateResponse,
  RemoveKnowledgeByTypeFromCandidateParameters
>("/cvp/CvpRemoveKnowledgeByTypeFromCandidate");
